module.exports = __webpack_public_path__ + "img/t1-11.591747d0.png";